import * as RadixCheckbox from '@radix-ui/react-checkbox'
import { styled } from '../../../config/stitches'

export const CheckBoxIndicator = styled(RadixCheckbox.CheckboxIndicator, {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
})
